"use client";

import React, { ReactNode } from "react";

import { Card, CardBody } from "@heroui/card";

import { COMPONENT_SIZES, SPACING } from "@/lib/constants/layoutConstants";
import { cn } from "@/lib/utils";

interface StatsCardProps {
  /**
   * Icon to display
   */
  icon: ReactNode;
  /**
   * Stat number/value
   */
  value: string | number;
  /**
   * Stat label/description
   */
  label: string;
  /**
   * Additional CSS classes
   */
  className?: string;
}

/**
 * Reusable stats card component with standardized icon, number, and label spacing
 * Uses org primary color for icons via CSS variables
 */
export function StatsCard({ className, icon, label, value }: StatsCardProps) {
  return (
    <Card className={cn("shadow-sm border border-default-200", className)}>
      <CardBody className={cn("text-center", SPACING.CARD_PADDING_MD)}>
        <div
          className={cn("flex flex-col items-center", SPACING.WITHIN_SECTION)}
        >
          {/* Icon */}
          <div className={cn("text-primary", COMPONENT_SIZES.ICON_LG)}>
            {icon}
          </div>
          {/* Value */}
          <div className={cn("text-3xl font-bold text-foreground")}>
            {value}
          </div>
          {/* Label */}
          <div className={cn("text-sm text-default-600")}>{label}</div>
        </div>
      </CardBody>
    </Card>
  );
}
